/**
 * ClientlessAuthTypes
 */

import { Environment, EnvironmentName, JWT } from './auth/common/configuration/AuthConfiguration'
import { DeviceInfoService } from './web/DeviceInfoService'
import { UserMetadataValue } from './engine/AuthEngineTypes'
import { RegCodeKey } from './util/StorageKeys'

export type ResourceID = string

/** @hidden */
export type ClientlessAPIConstructorParam = {
  adobeEnv?: Environment
  deviceInfoService: DeviceInfoService
  domainName?: string
  ecid?: string
  redirectUri?: string
  regCodeKey: RegCodeKey
  requestorId: string
  softwareStatement?: JWT
}

/** @hidden */
export type ClientlessAuthenticateParams = {
  regCode: string
  mvpdId: string
  redirectUrl: string
}

/** @hidden */
export interface MetadataEntry {
  value: UserMetadataValue
  encrypted: boolean // derived from state property, which should be either "plain" or "encrypted"
}

/**
 * Adobe's API environments
 *
 * We only support the production and staging environments. Pre-qualification could be added if needed.
 *
 * @hidden
 * @see https://experienceleague.adobe.com/en/docs/pass/authentication/tech-notes/environments/understanding-the-adobe-environments
 */
export const adobeEnvironments: Record<EnvironmentName, { RESTv2: string, DCR: string }> = {
  [EnvironmentName.PRODUCTION]: {
    RESTv2: 'https://sp.auth.adobe.com/api/v2',
    DCR:    'https://sp.auth.adobe.com/o'
  },
  [EnvironmentName.STAGING]: {
    RESTv2: 'https://sp.auth-staging.adobe.com/api/v2',
    DCR:    'https://sp.auth-staging.adobe.com/o'
  }
}

/** @hidden */
export interface PreauthorizationOptions {
  disableLocalCache?: boolean
  disableRemoteCache?: boolean
}
